import { useEffect, useState } from "react";
import Navbar from "../../components/navbar/navbar.jsx";
import { dadosLogin } from "../../zustand/zuztand";
import { useNavigate } from "react-router-dom";
import "../menufornecedores/menu-fornecedores.css"
import { Link } from "react-router-dom";

function MenuFornecedores(props) {
    const navigate = useNavigate();
    const [userLogado, setUserLogado] = useState("");
    const { changeIfLogado, ifLogado } = dadosLogin();
    const [larguraTela, setLarguraTela] = useState(window.innerWidth);
    const ehMobile = larguraTela < 1100;
        const [isOpen, setIsOpen] = useState(true);

    const menuItems = [
        { id: 0, title: 'Dashboard', icon: 'bi-bar-chart-line', color: 'primary' },
        { id: 1, title: 'Franquias', icon: 'bi-building', color: 'primary' },
        { id: 2, title: 'Franqueados', icon: 'bi-people', color: 'success' },
        { id: 3, title: 'Fornecedores', icon: 'bi-truck', color: 'warning' },
        { id: 4, title: 'Colaboradores', icon: 'bi-person-check', color: 'info' },
        { id: 5, title: 'Aniversariantes do mês', icon: 'bi-gift', color: 'danger' },
        { id: 6, title: 'Calendário Geral', icon: 'bi-calendar3', color: 'secondary' }
    ];

    function navegar() {
        navigate("/login");
    }

    function handleItemClick(item) {
        if (item.title === "Franquias") {
            setTimeout(() => {
                navigate("/franquias");
            }, 1000);
        } else if (item.title === "Franqueados") {
            setTimeout(() => {
                navigate("/franqueados");
            }, 1000);
        } else if (item.title === "Fornecedores") {
            setTimeout(() => {
                navigate("/fornecedores");
            }, 1000);
        } else if (item.title === "Colaboradores") {
            setTimeout(() => {
                navigate("/colaboradores");
            }, 1000);
        } else if (item.title === "Aniversariantes do mês") {
            setTimeout(() => {
                navigate("/menu-aniversariantes");
            }, 1000);
        } else if (item.title === "Calendário Geral") {
            setTimeout(() => {
                navigate("/calendario-geral");
            }, 1000);
        }else if (item.title === "Dashboard") {
            setTimeout(() => {
                navigate("/dashboard-franquias");
            }, 1000);
        }
    };

    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setLarguraTela(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return <>

        {ehMobile ? <>
              {/* Header do Menu */}
                <div className="mobile-menu-container">
                    <div className="menu-header">
                        <h3 className="menu-title">Menu Principal</h3>
                        <button
                            className="close-button "
                            onClick={navegar}
                        >
                            <i className="bi bi-x-lg " style={{ fontSize: '20px' }}></i>
                        </button>
                    </div>
                </div>

                {/* Conteúdo do Menu */}
                <div className={`menu-content ${isOpen ? 'show' : ''}`}>
                    <div className="menu-content-header">
                        <h2 className="menu-content-title">Menu Principal</h2>
                        <button
                            className="close-button-mobile"
                            onClick={navegar}
                            aria-label="Fechar menu"
                        >
                            <i className="bi bi-x-lg" style={{ fontSize: '20px' }}></i>
                        </button>
                    </div>

                    <div className="menu-items">
                        {menuItems.map((item) => {
                            return (
                                <a
                                    key={item.id}
                                    href="#"
                                    className="menu-item"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleItemClick(item);
                                    }}
                                >
                                    <div className={`menu-item-icon icon-${item.color}`}>
                                        <i className={`bi ${item.icon}`} style={{ fontSize: '20px' }}></i>
                                    </div>
                                    <span className="menu-item-text ms-2"> {item.title}</span>
                                </a>
                            );
                        })}
                    </div>
                </div>

                {/* Conteúdo da página principal */}
                <div className="main-content">
                    <div className="content-wrapper">
                        <div className="container">
                            {/* Conteúdo principal aqui */}
                        </div>
                    </div>
                </div>

        </> :
            <>
                <div className="d-flex container-fundo-forn">
                    <Navbar tela="fornecedores" />
                    <div className="row container-body-forn">
                        <img className="banner-fornecedores" src="https://firebasestorage.googleapis.com/v0/b/franqueadora-ce93d.appspot.com/o/banners%2Ffornecedores.png?alt=media&token=76299d40-6f67-431e-b3b9-38c709741a4b" alt="banner-franquias" />
                        <div className="fixed-bottom">
                            <div className="d-flex justify-content-center">
                                <div className="col-10 d-flex justify-content-between">
                                    <div className="col-1">
                                    </div>
                                    <div className="col-2 mb-2">
                                        <Link to="/fornecedores" className="btn-orange me-3 " aria-current="page">Dados Cadastrais</Link>
                                    </div>
                                    <div className="col-2 mb-2 ms-3">
                                        <Link to="/fornecedores-contratos" className="btn-orange me-3 " aria-current="page">Contratos</Link>
                                    </div>
                                    <div className="col-2 mb-2 ms-3">
                                        <Link to="/fornecedores-rebate" className="btn-orange me-3" aria-current="page">Rebate</Link>
                                    </div>
                                    <div className="col-2 mb-2 ms-3">
                                        <Link to="/fornecedores-catalogos" className="btn-orange me-3" aria-current="page">Catálogos</Link>
                                    </div>
                                    <div className="col-1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>}


    </>
}
export default MenuFornecedores;